import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
// Contem TODOS os @keyframes do design system (ds-spin, ds-modal-fade-in,
// ds-toast-slide-in, ds-dropdown-fade, ds-skeleton-shimmer, ds-sidebar-fade-in).
// Os componentes referenciam essas animacoes por nome, mas o arquivo nunca era
// importado — as animacoes nao existiam em runtime.
import '@nexora/design-system/styles.css';
import './styles/erpone.css';
import { registerServiceWorker } from './shared/offline/sw-registration';
import { initOfflineService } from './shared/offline/offline.service';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker only in production
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    registerServiceWorker().catch(console.error);
    initOfflineService();
  });
} else {
  // In development, unregister any existing service worker to prevent stale cache
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  }
}
